import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const CheckIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 8 6'}>
    <path
      d="M3.03555 5.1666C2.93555 5.1666 2.84388 5.13327 2.76888 5.05827L1.11055 3.39993C0.960551 3.24993 0.960551 3.0166 1.11055 2.8666C1.26055 2.7166 1.49388 2.7166 1.64388 2.8666L3.04388 4.25827L6.36888 0.941601C6.51888 0.791601 6.75222 0.791601 6.90222 0.941601C7.05222 1.0916 7.05222 1.32494 6.90222 1.47494L3.31054 5.05827C3.22721 5.13327 3.13555 5.1666 3.03555 5.1666Z"
      fill="white"
    />
  </BaseIcon>
);

export default CheckIcon;
